<template>
  <div class="content content-aligned">
    <h1>Lær at lave et platformspil</h1>
    <p>Følg vejledningerne i disse tre videoer, hvor du vil lære at lave dit eget platformspil.</p>
    <p>Hav en fane åben med videoerne og en anden fane med Scratch/CodingLab, hvor du koder dit spil.</p>
    <p>Sæt videoerne på pause undervejs, imens du koder.</p>

    <div class="content--centered">

      <EmbedYoutube class="video-tut-embed" id="hvrlQi8i9FU" title="Step 1" />
      <EmbedYoutube class="video-tut-embed" id="e5YF9P07-tQ" title="Step 2" />
      <EmbedYoutube class="video-tut-embed" id="yOWOypV5HD4" title="Step 3" />
      <EmbedYoutube class="video-tut-embed" id="TQ-sQOR-CtM" title="Step 4" />
      <EmbedYoutube class="video-tut-embed" id="4XI48Oehyyk" title="Step 5" />
      <EmbedYoutube class="video-tut-embed" id="C5oGyckSGNI" title="Step 5" />
    </div>
  </div>
</template>

<script>
import EmbedYoutube from "@/components/YoutubeEmbed";

export default {
  name: "VideoTutPlatformer",
  components: {
    EmbedYoutube
  },
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/pages/video-tutorials/video-tut-platformer.vue